var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-shell"},[_c('TopBar'),_c('main',{staticClass:"admin-main"},[_c('div',{staticClass:"admin-content"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }